import React, { useContext, useState } from 'react';
import SessionContext from '@providers/Session/SessionContext';
import { Link } from 'react-router-dom';

import * as S from './styles';

interface LogoProps {
  className?: string;
  style?: React.CSSProperties;
}

const Logo = ({ className, style }: LogoProps) => {
  const { logoImgName, isAlgarDomain } = useContext(SessionContext);
  const [imgLoaded, setImgLoaded] = useState(false);

  return (
    <Link to="/" className={className} style={{ height: '100%', ...style }}>
      {isAlgarDomain ? (
        <S.DefaultImage />
      ) : (
        <S.Img
          alt="loading"
          src={`/images/${logoImgName}`}
          onLoad={() => {
            setImgLoaded(true);
          }}
          onError={() => {
            setImgLoaded(false);
          }}
          style={{ opacity: imgLoaded ? 1 : 0 }}
        />
      )}
    </Link>
  );
};

export default Logo;
